<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="개인 정보 보호 정책" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">주식회사 제로 플레이스(이하, 「당사」라고 합니다.)에서는, 이용자님이 안심하고 이용 받을 수 있도록, 최저한의 개인정보를 제공 받고 있습니다.</span>
            <span class="text">또한 당사는 제공받은 개인정보의 보호에 대해 최대한의 주의를 기울이고 있습니다.</span>
            <span class="text">당사의 개인정보 보호에 대한 생각은 다음과 같습니다.</span>
            <br>
            <span class="text">(1) 당사에서는 회원님에 의해 등록된 개인 및 단체나 법인의 정보에 대해서는 최첨단의 기능이나 서비스를 개발·제공하기 위해서만 이용하여 회원 개인정보의 보호에 세심한 주의를 기울여야 합니다.</span>
            <span class="text">(2)이 개인 정보 보호 정책의 적용 범위는 당사가 제공하는 서비스입니다.</span>
            <span class="text">(3) 본 규약에 명기된 경우를 제외하고, 목적 이외의 이용은 하지 않습니다.</span>
            <span class="text">(4) 본 규약에 명기된 경우를 제외하고, 제3자에의 개시는 하지 않습니다.</span>
            <span class="text">(5) 그 외 본 규약에 규정된 방법으로의 적절한 관리를 정기적으로 실시합니다.</span>
            <span class="text">(6) 당사는 이용자의 허가 없이 프라이버시 정책의 변경을 할 수 있습니다.</span>
            <span class="text">당사가, 개인정보 취득 내용의 변경·이용 방법의 변경·공개 내용의 변경등을 했을 때에는, 이용자님이 그 내용을 알 수 있도록, 당사 홈페이지의 알림에 공개해, 이 프라이버시 정책에 반영하는 것으로 통지하겠습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제 1 항. 당사의 개인정보취급방침에 대한 사고방식이 적용되는 범위</span>
            <span class="text">(1) 당사의 프라이버시 정책에 대한 생각은 회원이 당사의 서비스를 이용하는 경우에 적용됩니다.</span>
            <span class="text">(2) 회원이 당사의 서비스를 이용할 때 수집되는 개인정보는 당사의 개인정보 보호에 대한 사고방식에 따라 관리됩니다.</span>
            <span class="text">(3) 당사의 개인정보보호의 사고방식은 당사가 직접 제공하는 서비스뿐이며, 다른 조직이나 회사 등의 서비스는 적용 범위외가 됩니다.</span>
            <span class="text">(4)당사의 서비스의 이용은, 이용자님의 책임에 있어서 행해지는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제 2 항. 당사의 개인정보 수집 및 이용</span>
            <span class="text">(1) 당사에서는 회원 여러분에게 최첨단의 기능이나 서비스를 개발·제공하기 위해 이용자 여러 개인정보가 필요합니다.</span>
            <span class="text">(2)등록 메일 주소·패스워드는, 이용자 자신의 책임에 있어서 관리를 부탁드립니다.</span>
            <span class="text">1. 비밀번호는 정기적으로 변경하며 타인이 유추하기 쉬운 이름이나 생년월일, 전화번호 등은 권장하지 않습니다.</span>
            <span class="text">2. 지인·친구 등이라도 공개·대여·양도하지 말아 주세요.</span>
            <span class="text">(3)수집된 개인정보는 당사의 서비스를 제공하기 위해 필요한 한도에서만 이용하며, 다음의 경우를 제외하고는 어떠한 제3자에게도 제공하지 않습니다.</span>
            <span class="text">1. 신용 카드 회사보다 카드 부정 이용의 조사를 위해 조회가 있었을 경우.</span>
            <span class="text">2. 회원에게 광고 선전을 위한 이메일 등을 송부할 때.</span>
            <span class="text">3. 개인정보에 관한 기밀유지계약을 체결하고 있는 업무위탁회사에 대하여 이용자에게 명시한 이용목적의 달성에 필요한 범위에서 개인정보의 취급을 위탁하는 경우.</span>
            <span class="text">4. 당사에 있어서의 회원의 행위가, 당사 방침, 고지, 당사의 이용 규약 등을 위반하고 있는 경우에, 다른 회원, 제삼자 또는 당사의 권리, 재산을 보호하기 위해서 필요로 인정될 때.</span>
            <span class="text">5. 법원, 행정기관의 명령 등 기타 법률의 규정에 따라 개인정보의 공개를 요구받은 경우 또는 범죄의 수사, 제3자에 대한 권리침해의 배제 또는 그 예방, 그 밖에 이에 준할 필요가 있을 때.</span>
            <span class="text">(4)회원은, 당사에 대하여, 개인정보를 위에 정하는 방법으로 이용하는 것에 대해 미리 동의하는 것으로 하고, 이의를 언급하지 않는 것으로 합니다.</span>
            <span class="text">(5) 또, 당사에서는 다음과 같은 경우, 당사의 비즈니스 파트너와 회원의 개인정보를 공유하는 일이 있습니다.</span>
            <span class="text">1. 회원용 특별 서비스 등, 사업적인 이유가 있는 경우.이 경우, 정보를 제공하기 전에 회원의 동의를 요구해, 동의 없이는 제공하지 않습니다.</span>
            <span class="text">2. 통계 자료 작성, 시장 조사, 데이터 분석을 실시하는 경우.이 경우, 특정 개인을 판별할 수 없도록 가공한 정보만을 제공합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
